import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-calculate-tax-box',
  templateUrl: './calculate-box.component.html',
  styleUrls: ['./calculate-box.component.scss']
})
export class CalculateTaxBoxComponent implements OnInit {

  DEFAULT_SALARY: number = 30000

  inputValue: string;
  selectedOption: string;

  edited: boolean = false

  options: any = [
    { label: "ต่อเดือน", value: "1" },
    { label: "ต่อปี", value: "0" },
  ]

  constructor() { }

  @Output() finishedCalChange = new EventEmitter<any>();

  ngOnInit(): void {
    this.selectedOption = "1"
    this.inputValue = this.DEFAULT_SALARY.toString()
  }

  onRadioChange(e: any): void {
    this.selectedOption = e

    if(!this.edited) {
      this.inputValue = (this.selectedOption == "1") ? this.DEFAULT_SALARY.toString() : (this.DEFAULT_SALARY * 12).toString()
    }
  }

  onValueChange(e: any): void {
    this.edited = true
  }

  calculate(): void {
    const inputNumber = (this.inputValue) ? parseFloat(this.inputValue).toFixed(2) : 0
    this.finishedCalChange.emit({
      salary: inputNumber,
      monthly: this.selectedOption,
    });
    document.documentElement.scrollTop = 0;
  }

}
